import type { ComponentMultiStyleConfig, StyleFunctionProps } from "@chakra-ui/react"

// Alerts and toasts: white panel, hairline border, status carried by the icon colour only
// (no tinted backgrounds, ADR 0001).
const statusColor: Record<string, string> = {
  success: "success",
  error: "danger",
  warning: "warning",
  info: "text",
  loading: "text",
}

const panel = ({ status }: StyleFunctionProps) => ({
  container: {
    bg: "surface",
    color: "text",
    border: "1px solid",
    borderColor: "line",
    borderRadius: "sm",
    boxShadow: "overlay",
  },
  title: { fontWeight: "semibold", fontSize: "sm" },
  description: { fontSize: "sm", color: "textMuted" },
  icon: { color: statusColor[status as string] ?? "text" },
  spinner: { color: statusColor[status as string] ?? "text" },
})

export const Alert: ComponentMultiStyleConfig = {
  parts: ["container", "title", "description", "icon", "spinner"],
  variants: {
    solid: panel,
    subtle: panel,
    "left-accent": panel,
    "top-accent": panel,
  },
}
